'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import { type ReactNode, useCallback, useEffect, useState } from 'react';
import { LastVisitedRouteContext } from '@/contexts/last-visited-route-context';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { LAST_VISITED_ROUTE_STORAGE_KEY } from '@/shared/constants/last-visited-route-storage-key';
import { isTrackablePrivateRoute } from '@/shared/functions/is-trackable-private-route';
function readStoredRoute(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(LAST_VISITED_ROUTE_STORAGE_KEY);
}
function persistRoute(pathname: string): void {
  sessionStorage.setItem(LAST_VISITED_ROUTE_STORAGE_KEY, pathname);
}
export function LastVisitedRouteProvider(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const router = useRouter();
  const [lastVisitedRoute, setLastVisitedRoute] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setLastVisitedRoute(readStoredRoute());
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== pathname) {
    t3 = () => {
      if (!isTrackablePrivateRoute(pathname)) {
        return;
      }
      persistRoute(pathname);
      setLastVisitedRoute(pathname);
    };
    t4 = [pathname];
    $[2] = pathname;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== lastVisitedRoute || $[6] !== router) {
    t5 = () => {
      const target = lastVisitedRoute ?? APP_ROUTES.PRIVATE.HOME;
      router.push(target);
    };
    $[5] = lastVisitedRoute;
    $[6] = router;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const resumeLastVisitedRoute = t5;
  let t6;
  if ($[8] !== lastVisitedRoute || $[9] !== resumeLastVisitedRoute) {
    t6 = {
      lastVisitedRoute,
      resumeLastVisitedRoute
    };
    $[8] = lastVisitedRoute;
    $[9] = resumeLastVisitedRoute;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t6) {
    t7 = <LastVisitedRouteContext.Provider value={t6}>{children}</LastVisitedRouteContext.Provider>;
    $[11] = children;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}